import { Skeleton as RNSkeleton } from "primereact/skeleton";

export const Skeleton = RNSkeleton;
